import { Routes } from '@angular/router';
import { AuthRoutes } from './core/auth/auth.routes';
import { AuthGuard } from './core/auth/services/authguard.guard';

export const routesProgrammatic: Routes = [
  // OLD REDIRECTS, SHORTCUTS
  {
    path: 'login',
    redirectTo: 'auth/login',
  },
  {
    path: 'forgot-password',
    redirectTo: 'auth/forgot-password',
  },

  // AUTH ROUTES
  {
    path: 'auth',
    canMatch: [AuthGuard],
    children: AuthRoutes,
  },

  // APP DASHBOARD ROUTES
  {
    path: '',
    canMatch: [AuthGuard],
    loadChildren: () => import('./app-routing-dashboard').then((m) => m.AppRoutingDashboard),
  },

  // GLOBAL --> LOGIN
  { path: '**', redirectTo: 'auth/login' },
];
